module.exports = __webpack_public_path__ + "toBride2-we-w-w.f265798f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-w-w.jpg
// module id = BkW9
// module chunks = 0